import styled from 'styled-components';
import Price from 'js/components/core/Price';

export default styled(Price)`
  line-height: 1.5rem;
`;
